import useLanguage from '@snowit/system/useLanguage';
import { MessageIllustration } from '@snowit/ui';

import s from './AccessDenied.module.scss';

type AccessDeniedProps = {
  reason?: string;
};

const AccessDenied = (props: AccessDeniedProps) => {
  const { t } = useLanguage();
  return (
    <MessageIllustration
      className={s.illustration}
      image={'img_snowman_error'}
      title={t('lzy.message.access_denied.title')}
      text={[t('lzy.message.access_denied.text'), props.reason].filter(Boolean).join('\n')}
    />
  );
};

export default AccessDenied;
